
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_1ozme_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1ozme_1",
  "root": "awsui_root_mx3cw_1ozme_48",
  "hidden": "awsui_hidden_mx3cw_1ozme_83",
  "alert-wrapper": "awsui_alert-wrapper_mx3cw_1ozme_137",
  "initial-hidden": "awsui_initial-hidden_mx3cw_1ozme_149",
  "header": "awsui_header_mx3cw_1ozme_154",
  "header-replacement": "awsui_header-replacement_mx3cw_1ozme_155",
  "action": "awsui_action_mx3cw_1ozme_159",
  "action-slot": "awsui_action-slot_mx3cw_1ozme_163",
  "action-button": "awsui_action-button_mx3cw_1ozme_164",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_1ozme_168",
  "text": "awsui_text_mx3cw_1ozme_200",
  "icon": "awsui_icon_mx3cw_1ozme_207",
  "message": "awsui_message_mx3cw_1ozme_210",
  "action-wrapped": "awsui_action-wrapped_mx3cw_1ozme_214",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_1ozme_218",
  "icon-size-big": "awsui_icon-size-big_mx3cw_1ozme_222",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_1ozme_226",
  "content": "awsui_content_mx3cw_1ozme_230",
  "content-replacement": "awsui_content-replacement_mx3cw_1ozme_231",
  "dismiss": "awsui_dismiss_mx3cw_1ozme_235",
  "dismiss-button": "awsui_dismiss-button_mx3cw_1ozme_241",
  "type-error": "awsui_type-error_mx3cw_1ozme_245",
  "type-warning": "awsui_type-warning_mx3cw_1ozme_253",
  "type-success": "awsui_type-success_mx3cw_1ozme_261",
  "type-info": "awsui_type-info_mx3cw_1ozme_269"
};
  